module.exports = __webpack_public_path__ + "assets/img/03.3efd8c71.png";